/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { isAuthenticated } from '../services/auth.service'
import { Grid } from '@material-ui/core'

import { useMutation } from '@apollo/client'
import { ADD_TO_CART } from './../queries'

import PhotoUploadComponent from '../components/Photo/photoUploadComponent'
import HomeServiceRouteComponent from '../components/Nav/HomeServiceRouteComponent'
import CategorieComponent from '../components/Product/CategorieComponent'
import CartComponent from '../components/Product/CartComponent'
import { useThemeData } from '../context/ThemeDataContext'
/* HOMEPAGE PRODUCTS OVERVIEW*/

function HomePrintService(props) {

  const {font_family, primary_color_2} = useThemeData().themeData.site.theme;

  const [active, setActive] = useState('routeOne')
  const [data, setData] = useState([])
  
  const [createShoppingcart,
    { loading: loadingCreateShoppingCart }]
    = useMutation(ADD_TO_CART
    )

  const changeData = (e, active, catname, product, effect, filename) => {
    setActive(active)
    if (catname && product && effect && filename) {
      isAuthenticated()

      e.preventDefault()
      e.stopPropagation()
      const newData = [{
        product_id: product.product_id,
        product_name: product.naam,
        product_file: filename,
        product_format: product.formaat,
        product_categorie: catname,
        shippingcost: product.shippingcost,
        photo_id: '1', // deze moet nog uit de photoupload getrokken worden
        effect_file_name: '',
        totaalprijs: product.actie_prijs,
        oorspronkelijke_prijs_ps: product.prijs,
        prijs_ps: product.actie_prijs,
        session_id: localStorage.getItem('session_id'),
        image_effect: effect,
        amount: '1',
        shoppingcart_rules: []
      }]
      if (!loadingCreateShoppingCart) {
        createShoppingcart({
          variables: {
            variables: {
              input: newData
           }
          }
        })
      }
    } else {
      setData(data.find(d => d.naam === catname))
    }
  }

  return (
    <Grid item xs={12} md={12} lg={12} xl={12} className="home" style={{
      fontFamily: `${font_family}`,
      color: `${primary_color_2}`,
    }}>
      <Grid container direction="row">
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <HomeServiceRouteComponent {...props} active={active} setActive={setActive} />
        </Grid>
      </Grid>
      <Grid container direction="row">
        {active === 'routeOne' ?
          <Grid item xs={12} md={12} lg={12} xl={12}
            className="page-edge">
            <CategorieComponent {...props} type='homePrintService' changeData={changeData} setData={setData} />
          </Grid>
          : active === 'routeTwo' ?
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <PhotoUploadComponent {...props} type="homePrintService" changeData={changeData} data={data} />
            </Grid>
            :
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <CartComponent {...props} type="homePrintService" shoppingcart={true} />
            </Grid>
        }
      </Grid>
    </Grid>
  )

}

export default React.memo(withTranslation('home')(HomePrintService))
